const LABEL = 'ամսական ցուցադրություն';

const MOBILE_COLS = 2;
const DESKTOP_COLS = 5;

const platforms = [
  { logo: '/images/smartTvAdvertising/logos/youtube.svg', width: 110, stat: '10 մլն' },
  { logo: '/images/smartTvAdvertising/logos/ivi.svg', width: 60, stat: '1 մլն' },
  { logo: '/images/smartTvAdvertising/logos/tvzavr.svg', width: 100, stat: '11 մլն' },
  { logo: '/images/smartTvAdvertising/logos/sputnik24.svg', width: 120, stat: '15 մլն' },
  { logo: '/images/smartTvAdvertising/logos/vintera.svg', width: 140, stat: '17 մլն' },
  { logo: '/images/smartTvAdvertising/logos/hdrezka.svg', width: 64, stat: '120K' },
  { logo: '/images/smartTvAdvertising/logos/kinogo.svg', width: 100, stat: '100K' },
  { logo: '/images/smartTvAdvertising/logos/gidonline.png', width: 140, stat: '80K' },
  { logo: '/images/smartTvAdvertising/logos/seasonvar.png', width: 140, stat: '30K' },
  { logo: '/images/smartTvAdvertising/logos/doramyclub.png', width: 140, stat: '120K' },
];

const Platforms = () => {
  return (
    <div className="bg-[#000000]">
      <div className="container py-[48px] md:pb-[96px] md:pt-[48px]">
        <h2 className="text-center font-[500] text-[28px] md:text-[36px] text-white mb-[40px] md:mb-[56px]">Որտե՞ղ է երևում գովազդը</h2>
        <div className="grid grid-cols-2 md:grid-cols-5">
          {platforms.map((item, index) => {
            const mobileVert = index % MOBILE_COLS !== 0;
            const desktopVert = index % DESKTOP_COLS !== 0;
            const mobileHoriz = index >= MOBILE_COLS;
            const desktopHoriz = index >= DESKTOP_COLS;

            const vertClass = mobileVert ? (desktopVert ? 'border-l' : 'border-l md:border-l-0') : desktopVert ? 'md:border-l' : '';
            const horizClass = mobileHoriz ? (desktopHoriz ? 'border-t' : 'border-t md:border-t-0') : desktopHoriz ? 'md:border-t' : '';

            return (
              <div
                key={item.logo}
                className={`group flex flex-col items-center px-[16px] py-[16px] md:py-[20px] border-[#898989] ${vertClass} ${horizClass}`}
              >
                <div className="flex flex-col items-center gap-[16px] transition-transform duration-300 group-hover:scale-[1.18]">
                  <img src={item.logo} alt="" style={{ width: item.width }} className="h-[50px] object-contain" />
                  <p className="text-center text-[14px] leading-[20px] max-w-[150px]">
                    <span className="text-[#9ebf91] font-[700]">{item.stat}</span> <span className="text-white/50 font-[400]">{LABEL}</span>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Platforms;
